import { Component, Input, OnInit } from '@angular/core';
import { BaseFilterCellComponent, FilterService } from '@progress/kendo-angular-grid';
import { CompositeFilterDescriptor } from '@progress/kendo-data-query';

@Component({
  selector: 'pt-kendo-multiselect-filter',
  template: `
    <kendo-multiselect
      class="width-100"
      [value]="selectedValue"
      [valuePrimitive]="true"
      [data]="data"
      [textField]="textField"
      [valueField]="valueField"
      (valueChange)="onChange($event)">
    </kendo-multiselect>
  `
})
export class PtKendoMultiselectFilterComponent extends BaseFilterCellComponent implements OnInit {
  @Input() filter: CompositeFilterDescriptor;
  @Input() data: any[];
  @Input() textField: string;
  @Input() valueField: string;
  @Input() filterPropertyField: string;

  get selectedValue(): any {
    const filter = this.filterByField(this.filterPropertyField);
    return filter ? filter.value : null;
  }

  constructor(filterService: FilterService) {
    super(filterService);
  }

  ngOnInit() { }

  onChange(value: any): void {
  }
}



// WEBPACK FOOTER //
// ./src/_foundation/kendo/components/pt-kendo-multiselect-filter/pt-kendo-multiselect-filter.component.ts